import { render, staticRenderFns } from "./air_quality_heatmap.vue?vue&type=template&id=62a0d096&"
import script from "./air_quality_heatmap.vue?vue&type=script&lang=js&"
export * from "./air_quality_heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports